module.exports = __webpack_public_path__ + "img/Previeweyezen-boost_livre.8a38578b.png";